import React, { useMemo } from "react";

import { Preview } from "@creatomate/preview";
import { Icon } from "@culturehq/components";

import AccordianCaptions from "components/common/AccordianCaptions";
import { Trans } from "app/utils";
import downloadCaptions from "../../utils/downloadCaptions";
import { isSubtitleText, updateSubtitlesText } from "../../utils";

interface DownloadOptionProps {
  preview: Preview;
}

const DownloadOption: React.FC<DownloadOptionProps> = ({ preview }) => {
  const { elements } = preview.state || { elements: [] };
  const allSubtitleElements = useMemo(() => elements.filter(
    element => isSubtitleText(element.source.name)
  ).map(element => element.source), [elements]);

  const accordionOptions = [
    {
      className: "DownloadDp-Option caption-div",
      content: (
        <>
          <Icon icon="download" />
          <Trans>Download Subtitles(VTT)</Trans>
        </>
      ),
      onClick: () => {
        const updatedSubtitles = updateSubtitlesText(allSubtitleElements);
        downloadCaptions("vtt", updatedSubtitles);
      }
    },
    {
      className: "DownloadDp-Option caption-div",
      content: (
        <>
          <Icon icon="download" />
          <Trans>Download Subtitles(SRT)</Trans>
        </>
      ),
      onClick: () => {
        const updatedSubtitles = updateSubtitlesText(allSubtitleElements);
        downloadCaptions("srt", updatedSubtitles);
      }
    }
  ];

  return (
    <div className="DownloadDp-Option accordion-header">
      <AccordianCaptions accordionOptions={accordionOptions} />
    </div>
  );
};

export default DownloadOption;
